import clsx from "clsx";
import type { PropsWithChildren } from "react";

export const PageContainer = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return <div className={clsx("flex w-full flex-col t:flex-nowrap gap-2 p-2", className)}>{children}</div>;
};
